var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNoImage = function SvgNoImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#6C62D1",
    rx: 40
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M35.5 32.75a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0m4.5-7.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15m-10.5 29.5c0-5.799 4.701-10.5 10.5-10.5s10.5 4.701 10.5 10.5h3c0-7.456-6.044-13.5-13.5-13.5s-13.5 6.044-13.5 13.5z",
    clipRule: "evenodd"
  })));
};
export default SvgNoImage;